import { Typography } from "antd";
import { useSlicerVariables, useWidgetData } from "../Contexts/dashboardHooks";
import { WidgetShell } from "./WidgetShell";
import { BodyMapView } from "@components/BodyMapView/BodyMapView";
import { WidgetInfoButton } from "../Info/WidgetInfoButton";
import { resolveTemplate } from "../Utils/resolveTemplate";

const { Text } = Typography;

export function BodyMapWidget({ id }: { id: string }) {
  const data = useWidgetData(id);
  const slicerValues = useSlicerVariables();

  if (!data || data.type !== "body_map") {
    return <WidgetShell id={id}><div /></WidgetShell>;
  }

  const hasData = Object.keys(data.bodyMap.dates).length > 0;
  const title = resolveTemplate(data.spec.display.title ?? "", slicerValues).resolved || "Body Map";

  return (
    <WidgetShell id={id}>
      <div className="chart-widget" data-grid-id={id}>
        <div className="widget-header">
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <Text strong style={{ fontSize: 18 }}>{title}</Text>
            <WidgetInfoButton id={id} />
          </span>
        </div>
        <div
          className="chart-widget-body"
          style={{ overflowY: "auto", padding: "0 10px" }}
        >
          {hasData ? (
            <BodyMapView
              data={data.bodyMap.dates}
              question_key={data.spec.question_key}
              playersPage={true}
              showBothSides
              showTitle={false}
              showDate={false}
            />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                padding: 16,
              }}
            >
              <Text type="secondary" style={{ fontSize: 13 }}>
                No bodymap data for the selected day
              </Text>
            </div>
          )}
        </div>
      </div>
    </WidgetShell>
  );
}
